import React, { useState } from 'react';
import { Alert, Sheet, Typography, Stack, Input, Select, Option, Button, Textarea, Divider, RadioGroup, Radio } from '@mui/joy';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useParams } from 'react-router-dom';
import { salvarEstado, salvarSku } from './LivrudoSlice';
import { converterDataParaString, gerarGUID, obterDataAtual } from './livrudo_helpers';
function generateSku() {
    const prefix = "SKU-";
    const randomNumbers = Array.from({ length: 8 }, () =>
        Math.floor(Math.random() * 10)
    ).join("");
    return `${prefix}${randomNumbers}`;
}
const AdicionarCompraLivroPage = () => {

    let { id } = useParams();
    var livros = useSelector(state => state.livrudo.db.livros)
    var skus = useSelector(state => state.livrudo.db.skus)
    var dispatch = useDispatch();

    var livro = livros.filter(f => f.id == id)

    React.useEffect(() => {

    }, []);
    const [form, setForm] = useState({
        livroId: '',
        sku: '',
        preco: '',
        data: '',
        plataforma: '',
        linkProduto: '',
        linkCompra: '',
        observacao: '',
        condicao: '',
        erro: "",
        ultimoEstado : "COMPRADO_AGUARDANDO_RECEBIMENTO",
        redirectAfter: false,
        
    });
    if (livro.length == 0) {
        return "Livro não encontrado"
    }

    livro = livro[0]

    if (form.sku.trim().length == 0) {
        var novoSku = false;

        while (!novoSku) {
            var sku = generateSku();

            var achou = skus.filter(s => s.sku == sku).length > 0

            if (!achou) novoSku = sku
        }


        setForm((prev) => ({ ...prev, "sku": novoSku }))
        setForm((prev) => ({ ...prev, "livroId": id }))
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleChangeLink = (e) => {

        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: (value) }));
    }

    const handleChangePreco = (e) => {
        const apenasNumeros = e.target.value.replace(/\D/g, '');

        const valorFormatado = (Number(apenasNumeros) / 100).toFixed(2);

        setForm((prev) => ({ ...prev, "preco": valorFormatado }))
    }

    const salva = (e) => {

        setForm((prev) => ({ ...prev, "erro": "" }))
        console.log(encodeURIComponent(form.linkCompra))
        console.log(encodeURIComponent(form.linkProduto))
        console.log(form)

        var error = false

        if (!form.preco || form.preco.trim().length == 0 || form.preco < 0) {
            error = "Preço inválido"
        } else if (!form.data || form.data.trim().length == 0) {
            error = "Data inválida"
        } else if (!form.plataforma || form.plataforma.trim().length == 0) {
            error = "Plataforma inválida"
        } else if (!form.condicao || form.condicao.trim().length == 0) {
            error = "Condição inválida"
        }

        if (error) {
            setForm((prev) => ({ ...prev, "erro": error }))
        } else {
            dispatch(salvarSku({
                ...form,
            }))
            dispatch(salvarEstado({
                    "sku" : form.sku,
                    "status" : "COMPRADO_AGUARDANDO_RECEBIMENTO",
                    "obs" : ""
            }))
            setForm((prev) => ({ ...prev, "redirectAfter": true }))
        }
    };

    if (form.redirectAfter) {
        return <Navigate to={"/livrudo/livros/" + livro.id} />
    }

    return (
        <Sheet
            variant="outlined"
            sx={{
                maxWidth: 500,
                margin: 'auto',
                padding: 2,
                borderRadius: 'md',
                boxShadow: 'lg',
                backgroundColor: 'neutral.softBg',
            }}
        >

            <Typography level="h4" textAlign="center" mb={2}>
                Nova compra
            </Typography>
            <Alert color="danger" sx={{ mb: 2 }}>
                {form.erro}
            </Alert>
            <Divider sx={{ marginBottom: 2 }} />
            <Stack spacing={2}>
            <Link to={"/livrudo/livros/" + livro.id}>
                <Button>Voltar</Button>
            </Link>
                <Input
                    label="SKU"
                    value={form.sku}
                    placeholder="SKU"
                    disabled={true}
                />
                <Input
                    label="Data"
                    type="date"
                    name="data"
                    value={form.data}
                    onChange={handleChange}
                    required
                />
                <Input
                    label="Preço"
                    type="number"
                    name="preco"
                    value={form.preco}
                    onChange={handleChangePreco}
                    placeholder="Ex: 120.00"
                    required
                />
                <Select
                    placeholder="Plataforma"
                    name="plataforma"
                    value={form.plataforma}
                    onChange={(e, value) => setForm((prev) => ({ ...prev, plataforma: value }))}
                    required
                >
                    <Option value="Amazon">Amazon</Option>
                    <Option value="OLX">OLX</Option>
                    <Option value="Enjoei">Enjoei</Option>
                    <Option value="Estante Virtual">Estante Virtual</Option>
                    <Option value="MercadoLivre">MercadoLivre</Option>
                    <Option value="Outra">Outra</Option>
                </Select>
                <Input
                    label="Link do Produto"
                    type="url"
                    name="linkProduto"
                    value={form.linkProduto}
                    onChange={handleChangeLink}
                    placeholder="Link do produto"
                />
                <Input
                    label="Link da Compra"
                    type="url"
                    name="linkCompra"
                    value={form.linkCompra}
                    onChange={handleChangeLink}
                    placeholder="Link da compra"
                />
                <Textarea
                    label="Observação"
                    name="observacao"
                    value={form.observacao}
                    onChange={handleChange}
                    minRows={3}
                    placeholder="Adicione detalhes adicionais..."
                />
                <Select
                    placeholder="Condição"
                    name="condicao"
                    value={form.condicao}
                    onChange={(e, value) => setForm((prev) => ({ ...prev, condicao: value }))}
                    required
                >
                    <Option value="NOVO">Novo</Option>
                    <Option value="USADO_QUASE_NOVO">Usado - Quase Novo</Option>
                    <Option value="USADO_MUITO_BOM">Usado - Muito bom</Option>
                    <Option value="USADO_BOM">Usado - Bom</Option>
                    <Option value="USADO_ACEITAVEL">Usado Aceitavel</Option>
                </Select>
                <Button onClick={salva} variant="solid" color="primary">
                    Enviar
                </Button>
            </Stack>
        </Sheet>
    );
};

export default AdicionarCompraLivroPage;
